/**
 * Shared field shell: left icon + focus ring (navy theme, sidebar-aligned).
 */
import { ChevronDown } from "lucide-react";
import "../../styles/fieldWithIcon.css";

const fieldBase =
  "w-full rounded-lg border border-slate-200 bg-white py-2.5 pl-10 text-sm text-slate-900 shadow-sm transition duration-200 placeholder:text-slate-400 " +
  "focus:border-sky-300 focus:outline-none focus:ring-2 focus:ring-sky-500/25 " +
  "disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-60";

const inputPad = "pr-3";
const selectPad = "pr-10 appearance-none";

export function InputWithIcon({ icon: Icon, className = "", inputClassName = "", ...inputProps }) {
  return (
    <div className={["relative", className].filter(Boolean).join(" ")}>
      <span className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-slate-400">
        {Icon ? <Icon className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden /> : null}
      </span>
      <input className={[fieldBase, inputPad, inputClassName].filter(Boolean).join(" ")} {...inputProps} />
    </div>
  );
}

export function SelectWithIcon({ icon: Icon, className = "", selectClassName = "", children, ...selectProps }) {
  return (
    <div className={["relative", className].filter(Boolean).join(" ")}>
      <span className="pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-slate-400">
        {Icon ? <Icon className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden /> : null}
      </span>
      <span className="pointer-events-none absolute right-3 top-1/2 z-10 -translate-y-1/2 text-slate-400">
        <ChevronDown className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden />
      </span>
      <select
        className={[fieldBase, selectPad, "field-select-native cursor-pointer", selectClassName].filter(Boolean).join(" ")}
        {...selectProps}
      >
        {children}
      </select>
    </div>
  );
}
